import axios, { AxiosError } from "axios";

import { ConsultationDetails } from "@teamprevent/common/model";
import { ReferralReportDetails } from "@teamprevent/common/referralReport/models";

const buildUrl = (ohCaseId: string) => `/api/ohCase/${ohCaseId}/referralReport`;

const getByViewTaskId = async (ohCaseId: string, viewReportTaskId: string) => {
    try {
        const result = await axios.get(`${buildUrl(ohCaseId)}`, { params: { viewReportTaskId } });
        return result.data;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError?.response?.status === 404) {
            return null;
        }

        throw ex;
    }
};

const getByWriteTaskId = async (ohCaseId: string, writeReportTaskId: string) => {
    try {
        const result = await axios.get(`${buildUrl(ohCaseId)}`, { params: { writeReportTaskId } });
        return result.data;
    }
    catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError?.response?.status === 404) {
            return null;
        }

        throw ex;
    }
};

const view = async (ohCaseId: string, viewReportTaskId: string): Promise<void> => {
    try {
        await axios.post(`${buildUrl(ohCaseId)}/${viewReportTaskId}/viewed`);
    }
    catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError?.response?.status === 404) {
            return null;
        }

        throw ex;
    }
};

const getConsultationDetailsByViewTaskId = async (ohCaseId: string, viewReportTaskId: string) => {
    try {
        const response = await axios.get<ConsultationDetails>(`${buildUrl(ohCaseId)}/consultation`, { params: { viewReportTaskId } });
        return response.data;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError?.response?.status === 404) {
            return null;
        }

        throw ex;
    }
};

const getConsultationDetailsByWriteTaskId = async (ohCaseId: string, writeReportTaskId: string) => {
    try {
        const response = await axios.get<ConsultationDetails>(`${buildUrl(ohCaseId)}/consultation`, { params: { writeReportTaskId } });
        return response.data;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError?.response?.status === 404) {
            return null;
        }

        throw ex;
    }
};

const getReportDetails = async (ohCaseId: string, writeReportTaskId: string, viewReportTaskId: string): Promise<ReferralReportDetails> => {
    try {
        const response = await axios.get(`${buildUrl(ohCaseId)}/reportDetails`, { params: { writeReportTaskId, viewReportTaskId } });
        return response.data as ReferralReportDetails;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError?.response?.status === 404) {
            return null;
        }

        throw ex;
    }
};

export const referralReportApi = {
    getByViewTaskId,
    getByWriteTaskId,
    view,
    getConsultationDetailsByViewTaskId,
    getConsultationDetailsByWriteTaskId,
    getReportDetails
};
